module.exports = __webpack_public_path__ + "static/media/titlePage.47a87ccd.txt";